import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const ChevronLeft = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="chevron left icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4326 2.58579C16.2137 3.36683 16.2137 4.63317 15.4326 5.41421L8.84686 12L15.4326 18.5858C16.2137 19.3668 16.2137 20.6332 15.4326 21.4142C14.6516 22.1953 13.3853 22.1953 12.6042 21.4142L3.19 12L12.6042 2.58579C13.3853 1.80474 14.6516 1.80474 15.4326 2.58579Z"
    />
  </svg>
)
